import { render, staticRenderFns } from "./TeacherWorkGroupByCourse.vue?vue&type=template&id=a6762aec&scoped=true"
import script from "./TeacherWorkGroupByCourse.vue?vue&type=script&lang=js"
export * from "./TeacherWorkGroupByCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6762aec",
  null
  
)

export default component.exports